import { createReducer } from '../../utils/createReducer';
import { createQuickButton } from '../../utils/messages';
import { SET_QUICK_BUTTONS } from '../actions/types';

const initialState = {
  quickButtons: []
};

const quickButtonsReducer = {
  [SET_QUICK_BUTTONS]: (state, { buttons }) => ({
    quickButtons: buttons.map((button) => createQuickButton(button))
  })
};

export default function quickButtons(state = initialState, action) {
  return createReducer(quickButtonsReducer, state, action);
}
